export default __webpack_public_path__ + "static/media/ga-002.d78c5a01.jpg";